import React, { useCallback, useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import ArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/KeyboardArrowDown';

import * as builder from '../../ducks/builder';
import TermDialog from '../../../app/components/other/Dialog/TermDialog';
import { useFormatMessage } from '../../../app/hooks';
import { IAppState } from '../../../app/store/rootDuck';
import { Typography, useMediaQuery } from '@mui/material';
import { useIntl } from 'react-intl';
import { makeStyles } from 'tss-react/mui';
import { useGetFavoritesCategories } from './useGetFavoritesCategories';
import { ICategoryItem } from '../../../app/pages/home/categories/interfaces';
import { actions as productCatalogActions } from '../../../app/store/ducks/product-catalog.duck';
import { toAbsoluteUrl } from '../../utils/utils';
import { ReactComponent as IconVk } from '../../../_base/layout/assets/layout-svg-icons/platform-vk-color-negative.svg';
import { ReactComponent as IconTelegram } from '../../../_base/layout/assets/layout-svg-icons/platform-telegram-color-negative.svg';

function splitIntoColumns(items: ICategoryItem[], columnsCount = 2) {
  const perColumn = Math.ceil(items.length / columnsCount);
  const columns = [];

  for (let i = 0; i < columnsCount; i++) {
    columns.push(items.slice(i * perColumn, (i + 1) * perColumn));
  }
  return columns;
}

const Footer = () => {
  const fm = useFormatMessage();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { classes } = styles();
  const [openDialog, setOpenDialog] = React.useState(false);
  const [dialogContentType, setDialogContentType] = React.useState('');
  const { getCategories, categories, loading } = useGetFavoritesCategories();
  const columns = splitIntoColumns(categories.filter(i => i.active) || [], 2);
  const [catalogOpened, setCatalogOpened] = React.useState(false);
  const [forBuyerOpened, setForBuyerOpened] = React.useState(false);
  const [informationOpened, setInformationOpened] = React.useState(false);
  const isMobile = useMediaQuery('(max-width:1024px)');

  const handleDialogOpen = useCallback(
    (contentType: string) => {
      setDialogContentType(contentType);
      setOpenDialog(true);
    },
    [dialogContentType]
  );

  const handleItem = (id: number) => {
    navigate('/products/catalog');
    dispatch(productCatalogActions.setCategoryIdActive(id));
  };

  useLayoutEffect(() => {
    getCategories();
  }, []);

  const handleDialogClose = useCallback(() => {
    setOpenDialog(false);
  }, []);

  const { footerClasses, footerContainerClasses, isAuthorized } = useSelector(
    (store: IAppState) => ({
      footerClasses: builder.selectors.getClasses(store, {
        path: 'footer',
        toString: true,
      }),
      footerContainerClasses: builder.selectors.getClasses(store, {
        path: 'footer_container',
        toString: true,
      }),
      isAuthorized: store.auth.user != null,
    })
  );

  const handleClickBecomeBtn = (role: 'ROLE_BUYER' | 'ROLE_VENDOR') => {
    localStorage.setItem('alignment', role);
    localStorage.setItem('authTab', '1');
    navigate('/auth/main');
  };

  return (
    <>
      <div className={classes.container}>
        <div className={classes.footer}>
          <div>
            <Typography component='p' className={classes.title}>
              Контакты
            </Typography>
            <div className={classes.containerContact}>
              <Typography component='p' className={classes.subTitleOpacity}>
                Телефон:
              </Typography>
              <Link
                to='tel:+74952753171'
                style={{ color: '#181c32' }}
                className={`kt-link kt-login__link-forgot ${classes.subTitle}`}
              >
                +7 495 275-31-71
              </Link>
            </div>
            <div className={classes.containerContact}>
              <Typography component='p' className={classes.subTitleOpacity}>
                Покупателям:
              </Typography>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: 4,
                }}
              >
                <Link
                  to='mailto:1@chipscan.ru'
                  style={{ color: '#181c32' }}
                  className={`kt-link kt-login__link-forgot ${classes.subTitle}`}
                >
                  1@chipscan.ru
                </Link>
                <Link
                  to='mailto:2@chipscan.ru'
                  style={{ color: '#181c32' }}
                  className={`kt-link kt-login__link-forgot ${classes.subTitle}`}
                >
                  2@chipscan.ru
                </Link>
              </div>
            </div>
            <div className={classes.containerContact}>
              <Typography component='p' className={classes.subTitleOpacity}>
                Поставщикам:
              </Typography>

              <Link
                to='mailto:morev@chipscan.ru'
                style={{ color: '#181c32' }}
                className={`kt-link kt-login__link-forgot ${classes.subTitle}`}
              >
                morev@chipscan.ru
              </Link>
            </div>
          </div>
          <div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: isMobile ? 'pointer' : 'default',
                marginTop: isMobile ? 16 : 0,
                paddingTop: isMobile ? 16 : 0,
                paddingBottom: isMobile ? 16 : 0,
                borderTop: isMobile ? '1px solid rgba(163, 167, 184, 0.5)' : 'none',
              }}
              onClick={() => isMobile && setCatalogOpened(!catalogOpened)}
            >
              <Typography component='p' className={classes.title}>
                {!isMobile ? 'Каталог товаров маркетплейса Chipscan.ru' : 'Каталог'}
              </Typography>
              {isMobile ? (
                <>
                  {catalogOpened ? (
                    <ArrowDropDownIcon style={{ width: 30, height: 30 }} />
                  ) : (
                    <ArrowRightIcon style={{ width: 30, height: 30 }} />
                  )}
                </>
              ) : null}
            </div>
            {catalogOpened || !isMobile ? (
              <div className={classes.containerCategories}>
                {columns.map((column, index) => (
                  <div className={classes.column} key={index}>
                    {column.map(item => (
                      <Link
                        key={item.id}
                        to='#'
                        style={{ color: '#181c32' }}
                        onClick={e => {
                          e.preventDefault();
                          item.id && handleItem(item.id);
                        }}
                        className={`kt-link kt-login__link-forgot ${classes.titleCategory}`}
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>
                ))}
              </div>
            ) : null}
          </div>
          <div
            style={{
              display: isMobile ? 'block' : 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              gap: 32,
            }}
          >
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  cursor: isMobile ? 'pointer' : 'default',
                  paddingTop: isMobile ? 16 : 0,
                  paddingBottom: isMobile ? 16 : 0,
                  borderTop: isMobile ? '1px solid rgba(163, 167, 184, 0.5)' : 'none',
                }}
                onClick={() => isMobile && setForBuyerOpened(!forBuyerOpened)}
              >
                <Typography component='p' className={classes.title}>
                  Покупателям
                </Typography>
                {isMobile ? (
                  <>
                    {forBuyerOpened ? (
                      <ArrowDropDownIcon style={{ width: 30, height: 30 }} />
                    ) : (
                      <ArrowRightIcon style={{ width: 30, height: 30 }} />
                    )}
                  </>
                ) : null}
              </div>
              {forBuyerOpened || !isMobile ? (
                <div className={classes.containerInfo}>
                  <a
                    href='https://feedback.chipscan.ru'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{ color: '#181c32' }}
                    className={`kt-link kt-login__link-forgot ${classes.titleCategory}`}
                  >
                    Поддержка
                  </a>
                </div>
              ) : null}
            </div>
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  cursor: isMobile ? 'pointer' : 'default',
                  paddingTop: isMobile ? 16 : 0,
                  borderTop: isMobile ? '1px solid rgba(163, 167, 184, 0.5)' : 'none',
                }}
                onClick={() => isMobile && setInformationOpened(!informationOpened)}
              >
                <Typography component='p' className={classes.title}>
                  Информация
                </Typography>
                {isMobile ? (
                  <>
                    {informationOpened ? (
                      <ArrowDropDownIcon style={{ width: 30, height: 30 }} />
                    ) : (
                      <ArrowRightIcon style={{ width: 30, height: 30 }} />
                    )}
                  </>
                ) : null}
              </div>
              {informationOpened || !isMobile ? (
                <div className={classes.containerInfo}>
                  <a
                    href='https://new.chipscan.ru'
                    target='_blank'
                    rel='noopener noreferrer'
                    className={`kt-link kt-login__link-forgot ${classes.titleCategory}`}
                    style={{ color: '#181c32' }}
                  >
                    Новости и события
                  </a>
                  <a
                    href='https://seller.chipscan.ru'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{ color: '#181c32' }}
                    className={`kt-link kt-login__link-forgot ${classes.titleCategory}`}
                  >
                    Поставщикам
                  </a>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className={classes.containerSubFooter}>
        <div className={classes.subFooter}>
          <a href='https://chipscan.ru' target='_blank' rel='noopener noreferrer'>
            <img
              style={{ height: 32, width: 180 }}
              src={toAbsoluteUrl('/images/chipscan-logo.png')}
            />
          </a>
          <div className={classes.containerLinks}>
            <Typography component='p' className={classes.copyright}>
              2024-2026 Маркетплейс электронных компонентов
            </Typography>
            <Typography component='p' className={classes.copyright}>
              ООО “Чипскан” | ИНН 972-800-8114 | КПП 772-801-001
            </Typography>
          </div>
          <div className={classes.containerLinks}>
            <Link
              to='#'
              rel='noopener noreferrer'
              style={{ color: '#e6e7e8' }}
              onClick={e => {
                e.preventDefault();
                handleDialogOpen('privacy_policy');
              }}
              className={`kt-link kt-login__link-forgot ${classes.copyright}`}
            >
              Политика конфиденциальности
            </Link>
            <Link
              to='#'
              rel='noopener noreferrer'
              style={{ color: '#e6e7e8' }}
              onClick={e => {
                e.preventDefault();
                handleDialogOpen('user_agreement');
              }}
              className={`kt-link kt-login__link-forgot ${classes.copyright}`}
            >
              Пользовательское соглашение
            </Link>
          </div>
          {!isMobile ? (
            <div className={classes.containerSites} style={{ marginTop: 0 }}>
              <a
                href='https://t.me/chipscanru'
                target='_blank'
                rel='noopener noreferrer nofollow'
                className={classes.linkIcon}
              >
                <IconTelegram />
              </a>
              <a
                href='https://vk.com/chipscan'
                target='_blank'
                rel='noopener noreferrer nofollow'
                className={classes.linkIcon}
              >
                <IconVk />
              </a>
            </div>
          ) : null}
          {/* <div className={classes.containerLinks}>
            <Link
              to='https://seller.chipscan.ru'
              target='_blank'
              rel='noopener noreferrer'
              style={{ color: '#e6e7e8' }}
              className={`kt-link kt-login__link-forgot ${classes.copyright}`}
            >
              seller.chipscan.ru
            </Link>

            <Link
              to='https://feedback.chipscan.ru'
              target='_blank'
              rel='noopener noreferrer'
              style={{ color: '#e6e7e8' }}
              className={`kt-link kt-login__link-forgot ${classes.copyright}`}
            >
              feedback.chipscan.ru
            </Link>
          </div> */}
          {isMobile ? (
            <div className={classes.containerSites} style={{ marginTop: 0 }}>
              <a
                href='https://t.me/chipscanru'
                target='_blank'
                rel='noopener noreferrer nofollow'
                className={classes.linkIcon}
              >
                <IconTelegram />
              </a>
              <a
                href='https://vk.com/chipscan'
                target='_blank'
                rel='noopener noreferrer nofollow'
                className={classes.linkIcon}
              >
                <IconVk />
              </a>
            </div>
          ) : null}
        </div>
      </div>
      <TermDialog
        isOpen={openDialog}
        handleClose={handleDialogClose}
        contentType={dialogContentType}
      />
    </>
  );
};

export default Footer;

const styles = makeStyles()(theme => {
  return {
    title: {
      fontSize: 22,
      color: '#181c32',
      fontWeight: 600,
      [theme.breakpoints.down(700)]: {
        fontSize: 18,
      },
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: '#E0E0E8',
      margin: '0 auto',
      width: '100%',
      padding: '0 20px',
    },
    containerSubFooter: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      alignItems: 'center',
      backgroundColor: '#181c32',
      margin: '0 auto',
      width: '100%',
      padding: '0 20px',
    },
    subFooter: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      maxWidth: 1440,
      width: '100%',
      padding: '32px 0',
      alignItems: 'center',
    },
    footer: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      maxWidth: 1440,
      width: '100%',
      padding: '32px 0',
      [theme.breakpoints.down(1290)]: {
        justifyContent: 'space-around',
      },
      [theme.breakpoints.down(1024)]: {
        display: 'block',
        justifyContent: 'space-between',
        gap: 16,
      },
    },
    subTitleOpacity: {
      fontSize: 14,
      fontWeight: theme.typography.fontWeightRegular,
      color: '#181c32',
      // opacity: '50%',
      [theme.breakpoints.down(700)]: {
        fontSize: 12,
        fontWeight: 'normal',
      },
    },
    subTitle: {
      fontSize: 18,
      fontWeight: 600,
      color: '#181c32',
      [theme.breakpoints.down(700)]: {
        fontSize: 14,
      },
    },
    containerContact: {
      marginTop: 24,
    },
    containerSites: {
      display: 'flex',
      flexDirection: 'row',
      gap: 12,
      marginTop: 22,
    },
    arrowIcon: {
      color: theme.palette.primary.main,
      width: '100%',
      height: '100%',
    },
    containerCategories: {
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: 16,
      gap: 32,
      [theme.breakpoints.down(700)]: {
        fontSize: 14,
        fontWeight: 'normal',
        flexDirection: 'column',
      },
    },
    column: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      gap: 5,
    },
    titleCategory: {
      fontSize: 14,
      fontWeight: theme.typography.fontWeightRegular,
      color: '#181c32',
      // opacity: '50%',
      cursor: 'pointer',
      [theme.breakpoints.down(700)]: {
        fontSize: 12,
        fontWeight: 'normal',
      },
    },
    containerInfo: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: 16,
      gap: 5,
    },
    copyright: {
      fontSize: 14,
      fontWeight: theme.typography.fontWeightRegular,
      color: '#e6e7e8',
      // opacity: '75%',
    },
    containerLinks: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      gap: 8,
    },
    linkIcon: {
      textDecoration: 'none',
    },
    link: {
      textDecoration: 'none',
      '& :hover': {
        textDecoration: 'underline',
      },
    },
  };
});
